export { default as ClinicsGroupsActions, types as ClinicTypes } from './actions';
export { default as ClinicsGroupsSagas } from './sagas';
export { default as ClinicsGroupsReducers } from './reducers';
